import currency from 'currency.js';
import React, { useState, useEffect } from 'react';
import { Spinner } from 'react-bootstrap';
import { numberWithCommas } from '../../utils/helper';
import moment from 'moment';
import { exportCSVFile } from '../../utils/helper';
import PAlert from '../../common/PAlert';
import useDidMountEffect from '../../utils/useDidMountEffect';
import _orderBy from 'lodash/orderBy';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const sortingStyle = {
    color: 'rgb(0, 151, 254)',
    cursor: 'pointer',
    marginLeft: '8px',
};


const Sorting = ({ sort = 'ASC' }) => {
    return sort === 'ASC'
        ? <FontAwesomeIcon
            icon={["fas", "chevron-up"]}
            style={sortingStyle}
        />
        : <FontAwesomeIcon
            icon={["fas", "chevron-down"]}
            style={sortingStyle}
        />;
};


const MainList = ({
    setMainList,
    mainList,
    handleAddFollowers,
    suToAdd,
    setSuToAdd,
    evalMainList,
    setEvalMainList,
    isBusy = false
}) => {
    const [selectedMainList, setSelectedMainList] = useState([]);
    const [selectedMainListObj, setSelectedMainListObj] = useState([]);
    const [showAlert, setShowAlert] = useState(false);
    const [alertBody, setAlertBody] = useState('');
    const [sortBy, setSortBy] = useState('login');
    const [orderBy, setOrderBy] = useState('ASC');

    const sortMainList = () => {
        let tmp = [...mainList];

        if (tmp.length <= 0) {
            return;
        }

        if (orderBy === 'DESC') {
            tmp.reverse();
        } else {
            tmp = tmp.sort((a, b) => {
                let da, db;
                if (sortBy === 'first_subscription_date') {
                    da = new Date(a[sortBy]),
                        db = new Date(b[sortBy]);
                    return da > db ? 1 : -1;
                }

                if (sortBy === 'total_payments') {
                    da = parseFloat(a[sortBy]),
                        db = parseFloat(b[sortBy]);
                    return da > db ? 1 : -1;
                }

                if (sortBy === 'total_followed') {
                    da = parseInt(a[sortBy], 10),
                        db = parseInt(b[sortBy], 10);
                    return da > db ? 1 : -1;
                }

                return a[sortBy].localeCompare(b[sortBy]);
            });
        }

        setMainList([...tmp]);
    };

    const rebuildSelectedSus = () => {
        let tmpSelectedSus = [...selectedMainList];
        let tmpObj = [...selectedMainListObj];

        suToAdd.forEach(suId => {
            const mainIndex = mainList.indexOf(suId);

            if (mainIndex >= 0) {
                tmpSelectedSus.push(mainList.id);
                tmpObj.push(mainList);
            }
        });
    };

    useEffect(() => {
        if (mainList && mainList.length > 0) {
            sortMainList();
        }
    }, []);

    useEffect(() => {
        if (suToAdd && suToAdd.length > 0) {
            rebuildSelectedSus();
        }
    }, [suToAdd]);

    useEffect(() => {
        if (mainList && mainList.length > 0) {
            sortMainList();
        }
    }, [suToAdd]);

    useDidMountEffect(() => {
        if (mainList && mainList.length > 0) {
            console.log({ orderBy, sortBy });
            sortMainList();
        }
    }, [orderBy, sortBy]);

    const handleSelectMainList = (su) => {
        let tmpSelectedSus = [...selectedMainList];
        let tmpObj = [...selectedMainListObj];

        const index = tmpSelectedSus.indexOf(su.id);

        if (index >= 0) {
            tmpSelectedSus.splice(index, 1);
            // tmpObj.splice(index, 1);
        } else {
            tmpSelectedSus.push(su.id);
            // tmpObj.push(su);
        }

        setSuToAdd(tmpSelectedSus);
        setSelectedMainList(tmpSelectedSus);
        setSelectedMainListObj(tmpObj);
    };

    const handleExportTagged = () => {
        const headers = {
            id: 'User ID',
            login: 'Login',
            email: 'Email',
            created_date: 'Created Payment Date',
            total_followed: 'PUs Following',
            total_payments: 'Total Spend',
            last_payment_date: 'Last Payment Date',
        };
        const tmpSelected = [...selectedMainListObj];

        if (tmpSelected && tmpSelected.length <= 0) {
            setAlertBody('Please select at least 1 SU from the main list');
            setShowAlert(true);
            return;
        }
        exportCSVFile(
            headers,
            tmpSelected,
            `CreatorSalesBoostWithSUsMainList-${moment().format('YYYY-MM-DD')}`
        );
    };

    const handleAddSelectedMainList = () => {
        handleAddFollowers();
        // setSelectedMainList([]);
        // setSelectedMainListObj([]);
    };

    useEffect(() => {
        if (evalMainList) {
            setSelectedMainListObj([]);
            setSelectedMainList([]);
            setEvalMainList(false);
        }
    }, [evalMainList]);

    const handleSort = (e, key) => {
        e.preventDefault();
        if (sortBy === key) {
            if (orderBy === 'DESC') {
                setOrderBy('ASC');
            } else {
                setOrderBy('DESC');
            }
        } else {
            setSortBy(key);
            setOrderBy('ASC');
        }
    };

    const handleTagAll = () => {
        const toAdd = mainList.map(list => list.id);
        setSelectedMainList(toAdd);
        setSuToAdd(toAdd);
        setSelectedMainListObj(mainList);
    };

    const handleClearTag = () => {
        const mainTmp = [...mainList];
        const filtered = mainTmp.filter(tmp => selectedMainList.indexOf(tmp.id) < 0);
        setMainList(filtered);
        setSelectedMainList([]);
        setSelectedMainListObj([]);
        setSuToAdd([]);
    };


    return <React.Fragment>
        <div className="main-list mb-4 mt-5">
            <div className="main-list__label">
                Main list of users to add to PU following
            </div>

            <div className="row actions mt-3">
                <div className="col-md-7">
                    <button
                        className="btn btn-primary"
                        onClick={handleAddSelectedMainList}
                        disabled={isBusy}
                    >
                        {
                            isBusy ? 'Adding...' : 'Add Followers'
                        }
                    </button>
                </div>

                <div className="col-md-5 main-list__subactions">
                    <button
                        className="btn btn-primary my-1"
                        onClick={handleExportTagged}
                    >
                        Export List
                    </button>
                    <button
                        className="btn btn-primary my-1"
                        onClick={handleTagAll}
                    >
                        Tag All
                    </button>
                    <button
                        className="btn btn-primary my-1"
                        onClick={handleClearTag}
                    >
                        Remove Tag
                    </button>
                </div>
            </div>

            <div className="details my-3">
                <strong>
                    {numberWithCommas(mainList ? mainList.length : 0)} Users to add to PU Following
                </strong>
            </div>

            {
                isBusy
                    ? <div className='my-3'><Spinner size="sm" variant='primary' animation='border' /> Updating data...</div>
                    : ''
            }

            <table className="table table-sm table-bordered table-striped table-hover mt-2 su-list">
                <thead>
                    <tr>
                        <th>Tag</th>
                        <th>
                            <a
                                href="#"
                                onClick={(e) => handleSort(e, 'login')}
                                className={sortBy === 'login' ? 'active' : ''}
                            >
                                {
                                    sortBy === 'login'
                                        ? <React.Fragment>Username <Sorting sort={orderBy} setSortBy={setOrderBy} /></React.Fragment>
                                        : 'Username'
                                }
                            </a>
                        </th>
                        <th>
                            <a
                                href="#"
                                onClick={(e) => handleSort(e, 'first_subscription_date')}
                                className={sortBy === 'first_subscription_date' ? 'active' : ''}
                            >
                                {
                                    sortBy === 'first_subscription_date'
                                        ? <React.Fragment>First Sub <Sorting sort={orderBy} setSortBy={setOrderBy} /></React.Fragment>
                                        : 'First Sub'
                                }
                            </a>
                        </th>
                        <th>
                            <a
                                href="#"
                                onClick={(e) => handleSort(e, 'total_payments')}
                                className={sortBy === 'total_payments' ? 'active' : ''}
                            >
                                {
                                    sortBy === 'total_payments'
                                        ? <React.Fragment>Spend <Sorting sort={orderBy} setSortBy={setOrderBy} /></React.Fragment>
                                        : 'Spend'
                                }
                            </a>
                        </th>
                        <th>
                            <a
                                href="#"
                                onClick={(e) => handleSort(e, 'total_followed')}
                                className={sortBy === 'total_followed' ? 'active' : ''}
                            >
                                {
                                    sortBy === 'total_followed'
                                        ? <React.Fragment>PUs <Sorting sort={orderBy} setSortBy={setOrderBy} /></React.Fragment>
                                        : 'PUs'
                                }
                            </a>
                        </th>
                    </tr>
                </thead>

                <tbody>
                    {
                        mainList && mainList.length > 0 && mainList.map(selected => {
                            return (
                                <tr key={selected.id}>
                                    <td>
                                        <input
                                            type="checkbox"
                                            value={selected.id}
                                            onChange={(e) => handleSelectMainList(selected)}
                                            checked={selectedMainList.indexOf(selected.id) >= 0}
                                        />
                                    </td>
                                    <td>
                                        {selected.login}
                                    </td>
                                    <td>
                                        {moment.utc(selected.first_subscription_date).local().format('lll')}
                                    </td>
                                    <td>
                                        {
                                            currency(selected.total_payments).format({ precision: 2 })
                                        }
                                    </td>
                                    <td>
                                        {selected.total_followed ? numberWithCommas(selected.total_followed) : 0}
                                    </td>
                                </tr>
                            );
                        })
                    }
                </tbody>
            </table>

            <PAlert
                show={showAlert}
                setShow={setShowAlert}
                body={alertBody}
                onClose={() => setShowAlert(false)}
                bodyStyle={{ textAlign: 'center' }}
                footerStyle={{ justifyContent: 'center' }}
            />
        </div>
    </React.Fragment>;
};

export default React.memo(MainList);
